import { render, staticRenderFns } from "./Calabozo.vue?vue&type=template&id=a91cd3c6&scoped=true"
import script from "./Calabozo.vue?vue&type=script&setup=true&lang=js"
export * from "./Calabozo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Calabozo.vue?vue&type=style&index=0&id=a91cd3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91cd3c6",
  null
  
)

export default component.exports